import { render } from "./AccordionConfiguration.vue?vue&type=template&id=1c617ee5&scoped=true"
import script from "./AccordionConfiguration.vue?vue&type=script&lang=js"
export * from "./AccordionConfiguration.vue?vue&type=script&lang=js"

import "./AccordionConfiguration.vue?vue&type=style&index=0&id=1c617ee5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c617ee5"],['__file',"src/components/accordion/AccordionConfiguration.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1c617ee5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1c617ee5', __exports__)) {
    api.reload('1c617ee5', __exports__)
  }
  
  module.hot.accept("./AccordionConfiguration.vue?vue&type=template&id=1c617ee5&scoped=true", () => {
    api.rerender('1c617ee5', render)
  })

}


export default __exports__